import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Routes from './routes/routes';
import Login from './pages/Login';
import { ConfigProvider } from 'antd';

import 'antd/dist/reset.css'; // Avval Ant Design reset
import './index.css'; // Tailwind bu yerda
import './shared/assets/styles/fonts.css';
import './shared/assets/styles/main.css';

function App() {
  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            headerBg: '#fff',
            headerColor: '#9898A6',
          },
          Input: {
            inputFontSize: 14,
          },
        },
        token: {
          colorPrimary: '#4060FF',
          colorBgContain: '#4060FF',
          colorText: '#000000',
          borderRadius: 10,
          fontWeightStrong: 450,
          fontSize: 18,
          controlInteractiveSize: 20,
        },
      }}
    >
      <BrowserRouter>
        <Route path='/login' exact component={Login} />
        <Routes />
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
